"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defer = void 0;

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.promise.js");

/**
 * Creates a new Promise and provides a way to `resolve` or `reject` that promise out of scope
 */
var defer = function defer() {
  var resolve;
  var reject;
  var promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};

exports.defer = defer;